export const environment = {
  apiUrl: 'https://formulando-app-staging-27682882559.southamerica-east1.run.app',
  production: false,
};
